export default __webpack_public_path__ + "static/media/T09D.4f2a78c6.png";